<template>
  <v-card elevation="0" class="pa-6">
    <div class="d-flex align-center mb-4">
      <h3 class="mb-0">{{ $t('finance.loanApplications.soilAnalysisSectionTitle') }}</h3>
    </div>

    <v-row>
      <v-col cols="12" md="4">
        <v-card elevation="1" class="pa-4 soil-metric-card">
          <div class="metric-label mb-1">{{ $t('finance.loanApplications.soilMetricNitrogenN') }}</div>
          <div class="metric-value">60 Kg N/hectare</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card elevation="1" class="pa-4 soil-metric-card">
          <div class="metric-label mb-1">{{ $t('finance.loanApplications.soilMetricPhosphorusP') }}</div>
          <div class="metric-value">100 Kg / hectare</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card elevation="1" class="pa-4 soil-metric-card">
          <div class="metric-label mb-1">{{ $t('finance.loanApplications.soilMetricPotassiumK') }}</div>
          <div class="metric-value">85 Kg / hectare</div>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="my-6" />

    <div class="text-body-2">
      <div class="font-weight-medium mb-2">{{ $t('finance.loanApplications.soilAnalysisPlaceholderTitle') }}</div>
      <div>
        {{ $t('finance.loanApplications.soilAnalysisPlaceholderBody') }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'SoilAnalysisReportDetails',
  props: {
    application: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.soil-metric-card {
  border-left: 4px solid #00BD73;
}

.metric-label {
  font-size: 14px;
  color: #555;
}

.metric-value {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
</style>

